import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { FC } from "react";

import { RouteName } from "@/consts";
import { useEth721Ownership } from "@/features/nft/hooks/useEth721Ownership";
import { ImageCardProps } from "@/features/post/components/postCard/type";
import { useUserContext } from "@/features/user/contexts/useUserContext";
import { usePostInfoWithLoggedInUserQuery } from "@/generated/generated-hooks";

import { CollectibleImageCard } from "./CollectibleImageCard";

const Eth721ActionButton = dynamic(
  () => import("@/features/nft/components/Eth721ActionButton"),
  { ssr: false },
);

const Eth721ImageCard: FC<ImageCardProps> = (props) => {
  const { post, isRender = true } = props;

  const { asset } = post;
  const { isNftOwner } = useEth721Ownership({ ...asset });

  // check if the component serves as preview when createPost,
  // if yes, return a preview image
  const router = useRouter();
  const { route } = router;
  const isPreview = route === `${RouteName.NewPost}/[slug]`;

  // check if the component is in public landing page
  // if yes: no need fetch subscription plan
  const { user, ready } = useUserContext();
  const isLanding = !user && route === `${RouteName.Landing}`;

  // fetch the remaining post data: images etc
  const { data: postInfo } = usePostInfoWithLoggedInUserQuery({
    variables: { slug: post.slug },
    context: { batch: true },
    skip: isPreview || !isRender || isLanding || !ready,
  });

  return (
    <CollectibleImageCard
      actionButton={
        <Eth721ActionButton
          tokenId={post.tokenId}
          isNFTOwner={isNftOwner}
          loadingAsset={!asset}
          listStatus={asset?.listStatus}
          logEventSource="image-card"
        />
      }
      asset={asset}
      assetLoading={!asset}
      post={post}
      postInfo={postInfo}
    />
  );
};

export default Eth721ImageCard;
